import { status } from 'skin/event/status'
// import { message } from 'skin/event'
// import dataUrl from '../../../../../../../config_task'

const click = (obj, ms, story, data, d, action) => {
	return status.action
}

export default click
